import React from "react";
import { Box } from "@mui/material";
import { COLORS, SIZES, DetailHeaderCell } from "../SkillSheetMainSectionUi";
import SkillSheetMainWorkContent from "./SkillSheetMainWorkContent";
import SkillSheetMainSkill from "./SkillSheetMainSkill";
import SkillSheetMainAchievement from "./SkillSheetMainAchievement";

/**
 * SkillSheetMainDetailDesktop
 * - PC専用
 * - 左：業務内容 / 右：使用技術（スキル）
 */
export default function SkillSheetMainDetailDesktop({
  workSections,
  skillSections,
  displayValues,
  rightColumnWidth = "20%",
}) {
  return (
    <Box sx={{ display: "grid", gap: 1 }}>
      <Box
        sx={{
          border: `1px solid ${COLORS.border}`,
          borderRadius: `${SIZES.radius}px`,
          overflow: "hidden",
          backgroundColor: COLORS.valueBg,
        }}
      >
        {/* ヘッダー */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `1fr ${rightColumnWidth}`,
            borderBottom: `1px solid ${COLORS.border}`,
          }}
        >
          <DetailHeaderCell withRightBorder>業務内容</DetailHeaderCell>
          <DetailHeaderCell>使用技術</DetailHeaderCell>
        </Box>

        {/* 本体 */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `1fr ${rightColumnWidth}`,
          }}
        >
          {/* 左：業務内容 */}
          <Box
            sx={{
              borderRight: `1px solid ${COLORS.border}`,
            }}
          >
            <SkillSheetMainWorkContent workSections={workSections} />
          </Box>

          {/* 右：スキル */}
          <SkillSheetMainSkill skillSections={skillSections} />
        </Box>
      </Box>

      {/* 成果/アピールポイント */}
      <SkillSheetMainAchievement displayValues={displayValues} />
    </Box>
  );
}
